// extracted by mini-css-extract-plugin
module.exports = {"copy":"styles_copy__2nHay","withIcon":"styles_withIcon__2DKfk","icon":"styles_icon__3WSkz"};